const BASE_URL = (import.meta as any).env?.VITE_API_BASE_URL || '/api';

async function request(path: string, init?: RequestInit) {
  const url = `${BASE_URL}${path}`;
  const token = localStorage.getItem('auth_token');
  
  const headers: HeadersInit = {
    'Accept': 'application/json'
  };

  // Only add Content-Type: application/json if body is NOT FormData
  // FormData requires the browser to set the Content-Type with boundary
  if (!(init?.body instanceof FormData)) {
    (headers as any)['Content-Type'] = 'application/json';
  }

  if (token) {
    (headers as any)['Authorization'] = `Bearer ${token}`;
  }

  const res = await fetch(url, {
    headers: {
      ...headers,
      ...init?.headers,
    },
    ...init,
  });
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(text || `HTTP ${res.status}`);
  }
  const contentType = res.headers.get('content-type') || '';
  if (contentType.includes('application/json')) {
    return res.json();
  }
  return undefined;
}

export const apiClient = {
  get: (path: string, options?: RequestInit) => request(path, { method: 'GET', ...options }),
  post: (path: string, body?: unknown, options?: RequestInit) => {
    const isFormData = body instanceof FormData;
    return request(path, { 
      method: 'POST', 
      body: isFormData ? body as BodyInit : (body ? JSON.stringify(body) : undefined),
      ...options
    });
  },
  put: (path: string, body?: unknown, options?: RequestInit) => {
    const isFormData = body instanceof FormData;
    return request(path, { 
      method: 'PUT', 
      body: isFormData ? body as BodyInit : (body ? JSON.stringify(body) : undefined),
      ...options
    });
  },
  delete: (path: string, options?: RequestInit) => request(path, { method: 'DELETE', ...options }),
};
